import React, { forwardRef, useRef, useState, useImperativeHandle } from "react";
import { RCCGrid, RCCHookToast, RCCRefModalProps, RCCServicesApi } from "react-common-components";
import { useForm } from "react-hook-form";
import LovDelimiter from "src/components/Lov/Delimiter";
import Modal from "src/components/Modal";
import { ModalCenter } from "src/components/Modal/styles";
import Attachments from "src/components/Attachments";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import { getTitleBudgetTypes } from "src/pages/FinancialManagement/interface";
import { standardErrorMessages } from "src/utils/errors";
import { IModalImportStructure, IRefModalImportStructure } from "./interface";

const ModalImportStructure: React.ForwardRefRenderFunction<IRefModalImportStructure, IModalImportStructure> = ({
	ofa001Id,
	onClose,
	type
}, ref) => {
	const { translate } = useTranslation();
	const { addToast } = RCCHookToast();
    
	// Modal export delimited structure
	const modalImportStructure = useRef<RCCRefModalProps>(null);
	const [subtitleModal, setSubtitleModal] = useState<string | undefined>(undefined);

	const { handleSubmit, control, setValue, reset } = useForm();
	const openModalImportStructure  = async () => {
		reset();
		setSubtitleModal(getTitleBudgetTypes(type, translate));
		modalImportStructure.current?.openModal();
	};
	const submitImportScructure = async (data: any) => {
		try{
			if(data.dropZone.length === 0){
				addToast({
					color: "yellow",
					description: translate("É necessário ao menos um arquivo para importar"),
					title: translate("Atenção")
				});
				return;
			}
			modalImportStructure.current?.setLoadingButton();
			const formData = new FormData();

			formData.append("Delimiter", data.delimiter);
			formData.append("BudgetPlanId", ofa001Id);
			formData.append("Type", type);

			data.dropZone.forEach((attach: any, index: number) => {
				formData.append(`Attachments[${index}]`, attach);
			});

			await RCCServicesApi.postRequest({
				method: "FinancialManagement/ImportStructureInHierarchy",
				contentType: "multipart/form-data",
				body: formData
			});


			addToast({
				color: "green",
				description: translate("Estrutura importada com sucesso"),
				title: translate("Sucesso")
			});
            
			modalImportStructure.current?.closeModal();
			onClose();
			modalImportStructure.current?.resetLoadingButton();
		}catch(err){
			modalImportStructure.current?.resetLoadingButton();
			standardErrorMessages(err, translate("Erro ao importar estrutura valores"), addToast);
		}
	};

	useImperativeHandle(ref, () => ({
		openModalImportStructure
	}));

	return (
		<Modal 
			ref={modalImportStructure}
			header={{
				title: translate("Importar estrutura"),
				subtitle: subtitleModal,
				icon: {
					name: "upload"
				}
			}}
			styleInline={`${ModalCenter} height: 80vh;`}
			onSubmit={handleSubmit(submitImportScructure)}
		>		
			<Title color="purple" size="md">
				{translate("Instruções")}
			</Title>
			<div style={{ marginLeft: "1rem"}}>
				<Title color="grey">
					{translate("Você pode utilizar arquivos nas extensões (.txt, .csv, .xls, .xlsx ou .ods)")}
				</Title>
				<Title color="grey">
					{translate("Cada arquivo poderá conter no máximo 20Mb de tamanho")}
				</Title>
				<Title color="grey">
					{translate("Não utilize cabeçalhos e linhas em branco")}
				</Title>
				<br />
				<RCCGrid container item alignItems="baseline">
					<RCCGrid container item xs={12} sm={6}>
						<Title color="grey">
							<RCCGrid container item direction="column">
								<RCCGrid container item style={{ fontWeight: "bold" }}>
									{translate("Arquivo")}
								</RCCGrid>							
								<RCCGrid container item >
								CXS10;Caxias do Sul;Rio Grande do Sul;Brasil
								</RCCGrid>
								<RCCGrid container item >
								[Em branco];Porto Alegre;Rio Grande do Sul;Brasil
								</RCCGrid>
								<RCCGrid container item >
								FLP30;Florianópolis;Santa Catarina;Brasil
								</RCCGrid>
							</RCCGrid>
						</Title>
					</RCCGrid>
					<RCCGrid container item xs={12} sm={6}>
						<Title color="grey">
							<RCCGrid container item direction="column">
								<RCCGrid container item style={{ fontWeight: "bold" }}>
									{translate("Hierarquia")}
								</RCCGrid>
								- Brasil
							
								<RCCGrid container item style={{marginLeft: "1rem"}}>
								- Rio Grande do Sul
								</RCCGrid>
								<RCCGrid container item style={{marginLeft: "2rem"}}>
								- Caxias do Sul (CXS10)
								</RCCGrid>
								<RCCGrid container item style={{marginLeft: "2rem"}}>
								- Porto Alegre
								</RCCGrid>
								<RCCGrid container item style={{marginLeft: "1rem"}}>
								- Santa Catarina
								</RCCGrid>
								<RCCGrid container item style={{marginLeft: "2rem"}}>
								- Florianópolis (FLP30)
								</RCCGrid>
							</RCCGrid>
						</Title>
					</RCCGrid>
				</RCCGrid>
			</div>
			<RCCGrid container item>
				<RCCGrid container item xs={12} sm={4} md={3} lg={2}>
					<LovDelimiter
						control={control}
						name="delimiter"
					/>
				</RCCGrid>
			</RCCGrid>
			<Attachments 
				name="dropZone"
				setValue={setValue}
				acceptedFormats=".csv,.txt,.xls,.xlsx,.ods"
			/>
		</Modal>
	);
};

export default forwardRef(ModalImportStructure);
